import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { AssignUnassignAssociatedCrewMembersErrorProps } from './types';
import { AssignUnassignAssociatedCrewMembersError } from '@bechtel/types';

const getErrorMessage = (error: AssignUnassignAssociatedCrewMembersErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case AssignUnassignAssociatedCrewMembersError.ASSIGN_UNASSIGN_ASSOCIATED_CREW_MEMBERS_ERRORED:
      return <Trans>Assign unassign crew members error.</Trans>;
    case AssignUnassignAssociatedCrewMembersError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const AssignUnassignError: FC<AssignUnassignAssociatedCrewMembersErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
      <ModalHeader title={t`Assign Unassign Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
